import React from 'react';
import { BookOpen } from 'lucide-react';
export function Header() {
  return <header className="w-full py-6 px-4 md:px-8 border-b border-warm-brown/20 bg-cream sticky top-0 z-50" data-id="element-103">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-2" data-id="element-104">
        <div className="flex items-center gap-3 text-forest-green" data-id="element-105">
          <BookOpen size={28} className="text-warm-brown" data-id="element-106" />
          <span className="font-handwritten text-3xl font-bold" data-id="element-107">
            Napftagebuch
          </span>
        </div>
        <span className="text-sm md:text-base text-warm-brown/80 italic font-serif" data-id="element-108">
          Ehrliche Geschichten aus dem Hundealltag von Petra & Rex
        </span>
      </div>
    </header>;
}